import React from "react";

export default function EditIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0002 2H8.00024C4.69124 2 2.00024 4.691 2.00024 8V21C2.00024 21.2652 2.1056 21.5196 2.29314 21.7071C2.48067 21.8946 2.73503 22 3.00024 22H16.0002C19.3092 22 22.0002 19.309 22.0002 16V8C22.0002 4.691 19.3092 2 16.0002 2ZM20.0002 16C20.0002 18.206 18.2062 20 16.0002 20H4.00024V8C4.00024 5.794 5.79424 4 8.00024 4H16.0002C18.2062 4 20.0002 5.794 20.0002 8V16Z"
        fill="#33403E"
      />
      <path
        d="M6.99976 14.9868V16.9858H8.99876L14.5278 11.4638L12.5298 9.46582L6.99976 14.9868Z"
        fill="#33403E"
      />
      <path
        d="M15.4711 10.522L13.4731 8.522L14.9961 7L16.9961 8.999L15.4711 10.522Z"
        fill="#33403E"
      />
    </svg>
  );
}
